import { HgSupportedLanguage } from '@smg-real-estate/domus';

export const DEFAULT_LANGUAGE = HgSupportedLanguage.DE;
